import React, { useState } from 'react'
import { AlertTriangle, Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { RichNoteEditor, NoteContent } from '../shared/RichNote'

const API_URL = process.env.REACT_APP_BACKEND_URL

export default function InformationsImportantesBlock({ sinistre, onRefresh, readOnly }) {
  const [saving, setSaving] = useState(false)
  const [focused, setFocused] = useState(false)

  async function save(html) {
    const next = (html || '').trim() || null
    if (next === (sinistre.informations_importantes || null)) return
    setSaving(true)
    try {
      const res = await fetch(`${API_URL}/api/sinistres/${sinistre.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ informations_importantes: next }),
      })
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail?.message || 'Erreur')
      toast.success('Informations importantes enregistrées')
      onRefresh?.()
    } catch (e) {
      toast.error(typeof e.message === 'string' ? e.message : 'Erreur de sauvegarde')
    } finally {
      setSaving(false)
    }
  }

  const hasContent = Boolean((sinistre.informations_importantes || '').trim())
  if (readOnly && !hasContent) return null

  return (
    <div className={`rounded-xl border-2 p-4 mb-6 ${hasContent || focused ? 'border-amber-400 bg-amber-50' : 'border-dashed border-amber-300 bg-amber-50/40'}`} data-testid="informations-importantes-block">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-sm font-bold text-amber-900 flex items-center gap-2 uppercase tracking-wide">
          <AlertTriangle size={16} className="text-amber-600" /> Informations importantes
        </h2>
        {saving && <Loader2 size={14} className="animate-spin text-amber-600" />}
      </div>
      {readOnly ? (
        <NoteContent contenu={sinistre.informations_importantes} className="text-sm text-amber-950 font-medium" />
      ) : (
        <div onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}>
          <RichNoteEditor
            value={sinistre.informations_importantes || ''}
            onChange={() => {}}
            onBlur={save}
            minRows={hasContent || focused ? 3 : 1}
            placeholder="Points d'attention à ne pas manquer sur ce dossier (gras et couleurs disponibles, enregistré en quittant la zone)…"
            testId="informations-importantes-input"
            className="border-amber-300 bg-white/70 focus-within:ring-amber-400 focus-within:border-amber-400"
            inputClass="text-amber-950 font-medium"
          />
        </div>
      )}
    </div>
  )
}
